"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DpFilterDropdown = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var react_i18next_1 = require("react-i18next");
var react_bootstrap_1 = require("react-bootstrap");
var isEmpty_1 = __importDefault(require("lodash/isEmpty"));
var isFunction_1 = __importDefault(require("lodash/isFunction"));
var classnames_1 = __importDefault(require("classnames"));
var DpFilterDropdown_styled_1 = require("./DpFilterDropdown.styled");
var Icon_1 = __importDefault(require("../Icon/Icon"));
var Item_1 = __importDefault(require("./Item"));
var api_1 = require("../../../api");
var lodash_1 = require("lodash");
var SingleSelectionItem_1 = __importDefault(require("./SingleSelectionItem"));
var renderSingleSelectItem = function (option, handleItemClick, disabled, setFocus, focus, index) {
    if (disabled === void 0) { disabled = false; }
    return ((0, jsx_runtime_1.jsx)(SingleSelectionItem_1.default
    // @ts-ignore
    , { setFocus: setFocus, index: index, focus: focus === index, option: option, handleItemClick: handleItemClick, disabled: disabled }, option.id));
};
var renderMultiSelectItem = function (option, setFocus, focus, index, handleItemChange, placeholder, disabled) {
    if (placeholder === void 0) { placeholder = ''; }
    if (disabled === void 0) { disabled = false; }
    return ((0, jsx_runtime_1.jsx)(Item_1.default
    // @ts-ignore
    , { setFocus: setFocus, index: index, focus: focus === index, option: option, handleItemChange: handleItemChange, disabled: disabled, dropdownTitle: placeholder }, option.id));
};
var DpFilterDropdown = function (_a) {
    var customAllSelectedLabel = _a.customAllSelectedLabel, customMultiSelectLabel = _a.customMultiSelectLabel, classes = _a.classes, options = _a.options, placeholder = _a.placeholder, disabled = _a.disabled, multipleSelect = _a.multipleSelect, showSearch = _a.showSearch, selectHandler = _a.selectHandler, currentOption = _a.currentOption, _b = _a.id, id = _b === void 0 ? 'filter-dropdown' : _b, ariaLabelText = _a.ariaLabelText, listAriaLabelText = _a.listAriaLabelText, _c = _a.visibleLabel, visibleLabel = _c === void 0 ? false : _c, firstInteractiveRef = _a.firstInteractiveRef;
    // ------------------------------ Const
    var t = (0, react_i18next_1.useTranslation)('common').t;
    // ------------------------------ State
    var _d = (0, react_1.useState)(false), open = _d[0], setOpen = _d[1];
    var _e = (0, react_1.useState)(''), searchText = _e[0], setSearchText = _e[1];
    var itemRef = (0, react_1.useRef)();
    var inputRef = (0, react_1.useRef)();
    var _f = (0, react_1.useState)(placeholder), buttonLabel = _f[0], setButtonLabel = _f[1];
    var _g = (0, react_1.useState)(false), selected = _g[0], setSelected = _g[1];
    var _h = (0, api_1.useRoveFocus)(options.length, itemRef), focus = _h[0], setFocus = _h[1];
    var role = 'listbox';
    var showSearchFeature = showSearch && open;
    // -------------------------------- Methods
    var setButtonLabelText = (0, react_1.useCallback)(function (selectedOptions) {
        var label = placeholder;
        var isSelected = false;
        if (selectedOptions.length > 0) {
            label = selectedOptions[0].title;
            if (multipleSelect && selectedOptions.length === options.length) {
                if (!(0, isEmpty_1.default)(customAllSelectedLabel)) {
                    label = customAllSelectedLabel;
                }
                else {
                    label = t('filterDropdown.allSelected', { label: placeholder === null || placeholder === void 0 ? void 0 : placeholder.toLowerCase() });
                }
            }
            else if (multipleSelect && selectedOptions.length > 1) {
                if (customMultiSelectLabel) {
                    label = "".concat(selectedOptions.length, " ").concat(t('filterDropdown.customSomeSelected', {
                        label: placeholder === null || placeholder === void 0 ? void 0 : placeholder.toLowerCase(),
                    }));
                }
                else {
                    label = "".concat(selectedOptions.length, " ").concat(t('filterDropdown.someSelected', {
                        label: placeholder === null || placeholder === void 0 ? void 0 : placeholder.toLowerCase(),
                    }));
                }
            }
            isSelected = true;
        }
        setButtonLabel(label);
        setSelected(isSelected);
    }, [
        customAllSelectedLabel,
        setButtonLabel,
        setSelected,
        multipleSelect,
        placeholder,
        options,
        t,
        customMultiSelectLabel,
    ]);
    var debouncedSetSearchText = (0, lodash_1.debounce)(function (text) { return setSearchText(text); }, 500);
    var onSearch = function (e) {
        e.persist();
        debouncedSetSearchText(e.target.value);
    };
    var resetSelectedOptions = function () { return options.map(function (option) { return (option.selected = false); }); };
    var getSelectedOptions = (0, react_1.useCallback)(function () { return options.filter(function (option) { return option.selected; }); }, [options]);
    var toggle = function () { return setOpen(!open); };
    (0, react_1.useEffect)(function () {
        if (open) {
            inputRef.current.focus();
        }
        else {
            inputRef.current.value = '';
            setSearchText('');
        }
    }, [open, searchText]);
    (0, react_1.useEffect)(function () {
        setButtonLabelText(getSelectedOptions());
    }, [options, setButtonLabelText, getSelectedOptions]);
    // --------------------------------- Render
    var createListItems = function () {
        var optionsCopy = [];
        if (searchText) {
            var regEx_1 = new RegExp(searchText.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&'), 'i');
            optionsCopy = options.filter(function (option) { return regEx_1.test(option.title); });
        }
        else {
            optionsCopy = options;
        }
        return optionsCopy.map(function (option, index) {
            var handleItemClick = function (e) {
                toggle();
                resetSelectedOptions();
                option.selected = true;
                var selectedOptions = getSelectedOptions();
                setButtonLabelText(selectedOptions);
                if ((0, isFunction_1.default)(selectHandler)) {
                    selectHandler(selectedOptions);
                }
            };
            var handleItemChange = function (checked) {
                option.selected = checked;
                var selectedOptions = getSelectedOptions();
                setButtonLabelText(selectedOptions);
                if ((0, isFunction_1.default)(selectHandler)) {
                    selectHandler(selectedOptions);
                }
                if ((0, isFunction_1.default)(currentOption)) {
                    currentOption(option, searchText ? options.findIndex(function (opt) { return opt.id === option.id; }) : index);
                }
            };
            return multipleSelect
                ? renderMultiSelectItem(option, setFocus, focus, index, handleItemChange, placeholder)
                : renderSingleSelectItem(option, handleItemClick, disabled, setFocus, focus, index);
        });
    };
    return ((0, jsx_runtime_1.jsxs)(DpFilterDropdown_styled_1.StyledDropdownContainer, { "data-testid": "DpFilterDropdown", children: [visibleLabel && ((0, jsx_runtime_1.jsx)("label", { htmlFor: id, className: "visible-label", children: placeholder })), (0, jsx_runtime_1.jsxs)(DpFilterDropdown_styled_1.StyledDropdown, { onToggle: toggle, className: (0, classnames_1.default)(classes), ref: itemRef, children: [(0, jsx_runtime_1.jsxs)(react_bootstrap_1.Dropdown.Toggle, { id: id, className: (0, classnames_1.default)('btn btn-outline-primary', { selected: selected }), disabled: disabled, as: "button", role: showSearchFeature ? 'searchbox' : 'button', "aria-label": ariaLabelText, ref: firstInteractiveRef || null, children: [(0, jsx_runtime_1.jsx)("span", { className: (0, classnames_1.default)({ 'd-none': !showSearchFeature }), children: (0, jsx_runtime_1.jsxs)("div", { className: "d-flex", children: [(0, jsx_runtime_1.jsx)(Icon_1.default, { className: (0, classnames_1.default)('search-icon', { 'd-none': searchText.length }), name: "search", size: 16 }), (0, jsx_runtime_1.jsx)(react_bootstrap_1.Form.Control, { autoComplete: "off", ref: inputRef, onChange: onSearch, className: "search-box", type: "text", placeholder: "Type to search" })] }) }), (0, jsx_runtime_1.jsx)("span", { className: (0, classnames_1.default)('text-truncate', { 'd-none': showSearchFeature }), title: buttonLabel, children: buttonLabel }), (0, jsx_runtime_1.jsx)(Icon_1.default, { name: open ? 'chevron-up' : 'chevron-down' })] }), open ? ((0, jsx_runtime_1.jsx)(react_bootstrap_1.Dropdown.Menu, { role: role, "aria-label": listAriaLabelText, as: "ul", className: multipleSelect ? 'multiple-select' : '', children: createListItems() })) : null] })] }));
};
exports.DpFilterDropdown = DpFilterDropdown;
exports.default = exports.DpFilterDropdown;
